import { IPropertyGroup, IPropertyGroupMethod } from "@app/propertyGroup/types";
import { UtilsObj } from "@hotelchamp/common";

import { log } from "./log";

class PropertyDetectionService {
    private propertyGroup: IPropertyGroup | undefined;

    public getPropertyGroup(): IPropertyGroup | undefined {
        return this.propertyGroup;
    }

    public setPropertyGroup(value: IPropertyGroup) {
        this.propertyGroup = value;
    }

    public resolveProperty(url: string) {
        const propertyDetectionConfiguration = this.propertyGroup?.property_detection;
        const properties = this.propertyGroup?.property_detection?.properties || [];

        if (!propertyDetectionConfiguration) {
            return undefined;
        }

        if (!this.propertyGroup) {
            return undefined;
        }

        if (properties.length === 0) {
            return undefined;
        }

        if (properties.length === 1) {
            return this.propertyGroup.properties[0].id;
        }

        let foundPropertyHash: string | undefined;

        if (propertyDetectionConfiguration.method === IPropertyGroupMethod.WindowObject) {
            const objectKey = propertyDetectionConfiguration.windowKey;
            const objectToSearchIn = objectKey?.split(".")[0] || "";
            const remainder = objectKey?.split(".").splice(1).join(".") || "";

            try {
                // eslint-disable-next-line no-eval
                const foundKey = UtilsObj.get(eval(objectToSearchIn), remainder, "");

                foundPropertyHash = Object.keys(properties).find((propertyKey, index) => {
                    const key = UtilsObj.get(properties, propertyKey);

                    return key === foundKey;
                });
            } catch (e) {
                log.warn(`Property detection service: could not resolve property identifier, global."${objectToSearchIn}" not available`);
                return undefined;
            }
        }

        if (propertyDetectionConfiguration.method === IPropertyGroupMethod.UrlEndsWith) {
            foundPropertyHash = Object.keys(properties).find((propertyKey) => {
                const valueToCheck = UtilsObj.get(properties, propertyKey) as string;

                return url.endsWith(valueToCheck);
            });
        }

        if (propertyDetectionConfiguration.method === IPropertyGroupMethod.UrlStartsWith) {
            foundPropertyHash = Object.keys(properties).find((propertyKey) => {
                const valueToCheck = UtilsObj.get(properties, propertyKey) as string;

                return url.startsWith(valueToCheck);
            });
        }

        if (propertyDetectionConfiguration.method === IPropertyGroupMethod.UrlContains) {
            foundPropertyHash = Object.keys(properties).find((propertyKey) => {
                const valueToCheck = UtilsObj.get(properties, propertyKey) as string;

                return url.indexOf(valueToCheck) !== -1;
            });
        }

        return foundPropertyHash;
    }
}

export const propertyDetectionService = new PropertyDetectionService();
